module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/cloud/sorority-cloud-02-large-46f7f9bc1b0cc10c3775a3d1b3ca04ca.jpg";